<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close"></div>
        <div class="skip" v-on:click="close" v-if="!d || !d.ok">
          Lewati
        </div>
        <div class="tree"></div>
        <div class="mcIn" v-if="st === 0">
          <h4>Tanam <span>Pohon</span> Di Hutan<br />Tanpa Ke Hutan</h4>
          <p class="text-left">
            Selimut polusi di udara bisa berkurang kalau hutan yang gundul ditanami lagi.
          </p>
          <p class="text-left">Misi kamu: menanam pohon di hutan</p>
          <p class="text-left">Cara: </p>
          <ul class="text-left">
            <li>Ikuti challenge pilihanmu setiap hari dan kumpulkan poinnya.</li>
            <li>Saat terkumpul 1.400 poin, akan ada 1 pohon yang ditanam atas namamu di hutan</li>
          </ul>
          <button v-on:click="close" v-if="d && d.ok">Mulai Bermain</button>
          <button v-on:click="st = 1" v-else>Mulai</button>
        </div>
        <div class="mcIn mission" v-else-if="st === 1">
          <h4>Ikuti Semua <span>Misi</span></h4>
          <p>Ikuti semua misi yang ada di Team Up For Impact Everyday.
            Dapatkan 100 poin untuk setiap misi yang kamu ikuti dan 100
            poin lagi kalau kamu share misimu di medsos.</p>
          <button v-on:click="st = 2">Berikutnya</button>
          <img src="../assets/missions.jpg">
          <img class="missionMb" src="../assets/missions-mobile.jpg">
        </div>
        <div class="mcIn acc" v-else-if="st === 2">
          <h4>Hias <span>Pohonmu</span></h4>
          <p>Buat pohonmu lebih menarik dengan menambahkan aksesori
            yang ditukar dengan poinmu.</p>
          <button v-on:click="st = 3">Berikutnya</button>
          <img src="../assets/accs.png">
        </div>
        <div class="mcIn mission planting" v-else-if="st === 3">
          <h4>Satu Pohon Ditanam <span>Atas Namamu</span></h4>
          <p>Saat kamu mencapai 1.400 poin, ada satu pohon yang
            akan ditanam di hutan atas namamu. Kamu akan mendapat
            pemberitahuan melalui email mengenai detail lokasi
            penanaman pohonmu.</p>
          <button v-on:click="close">Ikuti Misi</button>
          <img src="../assets/planting-tree.jpg">
          <img class="missionMb" src="../assets/planting-tree-mb.jpg">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      d: null,
      st: 0,
    };
  },
  methods: {
    open(d, next) {
      this.d = d;
      this.next = next;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 60px 100px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      max-width: 460px;
      background-color: #e6e1c1;
      background-image: url(../assets/modal-bg2.jpg);
      background-size: auto 100%;
      background-position: left;
      background-repeat: no-repeat;
      text-align: center;
      .tree{
        position: absolute;
        left: 0; right: -10px; bottom: 0; top: 0;
        background-image: url(../assets/FG-Kanan.svg);
        background-size: auto 120px;
        background-position: right bottom;
        background-repeat: no-repeat;
      }
      .skip{
        position: absolute;
        right: 10px; top: 10px;
        padding: 4px 10px;
        opacity: .65;
        font-size: 14px;
        cursor: pointer;
        transition: all .3s ease;
        z-index: 3;
        &:hover{
          opacity: 1;
        }
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        z-index: 3;
        display: none;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      @media (max-width: 680px) {
        width: auto;
        left: 10px; right: 10px;
        max-width: none;
        box-sizing: border-box;
        padding: 60px 20px;
      }
      .mcIn{
        position: relative;
        z-index: 3;
        &.mission{
          padding-left: 210px;
          text-align: left;
          min-height: 350px;
          box-sizing: border-box;
          padding-top: 60px;
          @media (max-width: 680px) {
            padding: 0;
            min-height: 0;
            text-align: center;
          }
          img{
            position: absolute;
            left: 0; top: -20px;
            width: 180px;
            border-radius: 5px;
            @media (max-width: 680px) {
              position: static;
              display: none;
              border-radius: 10px 10px 0 0;
            }
            &.missionMb{
              display: none;
              @media (max-width: 680px) {
                display: block;
                width: 98%;
                margin: 30px auto -60px;
              }
            }
          }
          &.planting{
            margin: 0 -60px;
            padding-left: 290px;
            @media (max-width: 680px) {
              padding: 0;
              margin: 0;
            }
            img{
              width: 260px;
              @media (max-width: 680px) {
                width: 90%;
                border-radius: 10px 10px 0 0;
              }
            }
          }
        }
        &.acc{
          img{
            margin-top: 30px;
            height: 120px;
            @media (max-width: 680px) {
              height: auto;
              width: 90%;
              margin-bottom: -20px;
            }
          }
        }
      }
      h4{
        margin: 0 0 10px;
        font-size: 24px;
        color: #5351a4;
        font-family: 'GolosUIWebBold', sans-serif;
        span{
          color: #f14724;
        }
        @media (max-width: 680px) {
          font-size: 22px;
          margin-bottom: 6px;
        }
      }
      p{
        margin: 0 0 12px;
        color: #767676;
        color: #444;
        @media (max-width: 680px) {
          font-size: 15px;
        }
      }
      button{
        padding: 10px 16px;
        font-size: 18px;
        margin-top: 10px;
        min-width: 140px;
        border-radius: 3px;
      }
    }
  }
</style>
